import React, { useState, useContext } from "react";
import "./style/MobileNav.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faBell,
  faThLarge,
  faHeart,
  faSearch,
  faBook,
  faStream,
  faUser,
  faClone,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Link, NavLink, useHistory } from "react-router-dom";
import Badge from "@material-ui/core/Badge";
import { Context, BasketContext, UserContext } from "../context/Context";
import MenuIcon from "@material-ui/icons/Menu";
import Avatar from "@material-ui/core/Avatar";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { auth } from "../../Firebase";

function MobileNav() {
  const [text, setText] = useState("");
  const [term, setTerm] = useContext(Context);

  const [basket, setBasket] = useContext(BasketContext);
  const [user, setUser] = useContext(UserContext);
  const history = useHistory();

  const HandleChange = (e) => {
    setText(e.target.value);
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    setTerm(text);
    history.push("/Browse");
  };

  const logOut = () => {
    auth.signOut();
  };

  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState("none");

  const handleDrawer = () => {
    if (open === true) {
      setOpen(false);
      setDisplay("none");
    } else {
      setOpen(true);
      setDisplay("block");
    }
  };
  return (
    <div className="mobileNav">
      <MenuIcon onClick={handleDrawer} />
      <div>
        <form onSubmit={HandleSubmit}>
          <input
            type="text"
            placeholder="search for book"
            onChange={HandleChange}
          />
        </form>
      </div>
      <div>
        <Link to="/Basket">
          <Badge badgeContent={basket.length} color="error">
            <FontAwesomeIcon icon={faShoppingCart} />
          </Badge>
        </Link>
        <Badge variant="dot" color="error">
          <FontAwesomeIcon icon={faBell} />
        </Badge>
      </div>
      <div
        className="drawer"
        style={{ display: `${display}` }}
        onClick={handleDrawer}
      >
        <div className="user">
          <Avatar src={user?.photoURL} />
          <div className="user__info">
            <p>{user?.displayName}</p>
            <span>{user?.email}</span>
          </div>
          <ExitToAppIcon className="logOutBtn" onClick={logOut} />
        </div>
        <div className="menu">
          <ul>
            <NavLink exact to="/" activeClassName="active">
              <li>
                <FontAwesomeIcon icon={faThLarge} /> <p>Home</p>
              </li>
            </NavLink>
            <NavLink to="/ForYou">
              <li>
                <FontAwesomeIcon icon={faHeart} /> <p>For you</p>
              </li>
            </NavLink>
            <NavLink to="/Browse">
              <li>
                <FontAwesomeIcon icon={faSearch} /> <p>Browse</p>
              </li>
            </NavLink>
            <li>
              {" "}
              <FontAwesomeIcon icon={faBook} /> <p>Bestsellers</p>
            </li>
            <li>
              {" "}
              <FontAwesomeIcon icon={faStream} /> <p>Daily top 100</p>
            </li>
            <li>
              {" "}
              <FontAwesomeIcon icon={faUser} /> <p>Authors</p>
            </li>
            <li>
              {" "}
              <FontAwesomeIcon icon={faClone} /> <p>Amazon books</p>
            </li>
            <li>
              {" "}
              <FontAwesomeIcon icon={faPlus} /> <p>New releases</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MobileNav;
